import type { UIComponent } from "@gik/core/types/UI";
import bemBlock from "@gik/core/utils/bemBlock";
import withComponentErrorBoundary from "@gik/core/utils/withComponentErrorBoundary";
import { SamplePagesGridWithData } from "@gik/marketing/components/SamplePages/SamplePagesGridWithData";
import { PageSection } from "@gik/ui-legacy/gik/PageSection";
import type React from "react";
import { useTranslation } from "react-i18next";
import { translationKeys } from "./i18n/en";

export type ISamplePagesSectionProps = {} & UIComponent;

function TipsSamplePagesSectionComp({
	className,
}: ISamplePagesSectionProps): React.ReactElement {
	const bem = bemBlock("tips-sample-pages-section");
	const { t } = useTranslation();

	return (
		<PageSection
			variant="solid-neutral"
			className={bem(null, null, className)}
			id="sample-pages"
		>
			<h2 className={bem("title")}>{t(translationKeys.samplePages)}</h2>
			<SamplePagesGridWithData perPage={10} loadMoreButton />
		</PageSection>
	);
}

export const TipsSamplePagesSection = withComponentErrorBoundary(
	TipsSamplePagesSectionComp,
);
